module.exports = __webpack_public_path__ + "img/american_express.9e085a50.png";